import React from 'react';

import { Box, Inline } from '@atlaskit/primitives/compiled';
import { Card } from '@atlaskit/smart-card';
import { token } from '@atlaskit/tokens';
import { cssMap } from '@atlaskit/css';
import { IconButton } from '@atlaskit/button/new';
import CrossIcon from '@atlaskit/icon/core/cross';

import type { AdditionalResource } from '../../../../../types/additionalResource';

const styles = cssMap({
	smartLinkContainer: {
		maxHeight: '24px',
		overflow: 'hidden',
	},
	buttonContainer: {
		paddingInline: token('space.050'),
	},
});

export type AdditionalResourceSelectionProps = {
	resource: AdditionalResource;
	removeResource: (ari: string) => void;
};

export const AdditionalResourceSelection = ({
	resource,
	removeResource,
}: AdditionalResourceSelectionProps) => {
	const { ari, url } = resource;

	return (
		<Inline spread="space-between" xcss={styles.smartLinkContainer}>
			<Card url={url} appearance="inline" truncateInline />
			<Box xcss={styles.buttonContainer}>
				<IconButton
					label="remove-briefing-resource"
					appearance="subtle"
					icon={CrossIcon}
					spacing="compact"
					onClick={() => removeResource(ari)}
				/>
			</Box>
		</Inline>
	);
};
